import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const ContactsIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66667 17.6001V17.0666C6.66667 15.5938 7.86057 14.4001 9.33333 14.4001C10.8061 14.4001 12 15.5936 12 17.0664V17.6001M13.6 10.1334H16.8M13.6 13.3334H16.8M4 19.7334H20M7.73333 4.26672V6.93339M16.2667 4.26672V6.93339M9.33333 9.06672C8.44968 9.06672 7.73333 9.78307 7.73333 10.6667C7.73333 11.5504 8.44968 12.2667 9.33333 12.2667C10.217 12.2667 10.9333 11.5504 10.9333 10.6667C10.9333 9.78307 10.217 9.06672 9.33333 9.06672ZM5.6 6.93339H18.4C18.9891 6.93339 19.4667 7.41095 19.4667 8.00006V16.5334C19.4667 17.1225 18.9891 17.6001 18.4 17.6001H5.6C5.0109 17.6001 4.53333 17.1225 4.53333 16.5334V8.00006C4.53333 7.41095 5.0109 6.93339 5.6 6.93339Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
